import React, { useEffect, useState } from "react";
import "intl-tel-input/build/css/intlTelInput.css";
import IntlTelInput from "intl-tel-input/react";
import { useCountry } from "../../context/country";
const IntlTelInputBox = ({ setFullPhone, selectedPhone, handleIntel }) => {
  const [country, setCountry] = useCountry();
  const [number, setNumber] = useState("");
  const [isValid, setIsValid] = useState("");
  const [errorCode, setErrorCode] = useState(false);
  const [currentCountry, setCurrentCountry] = useState("");
  var errorMap = [
    "Invalid number",
    "Invalid country code",
    "Too short",
    "Too long",
    "Invalid number",
  ];
  useEffect(() => {
    handleIntel(isValid);
  }, [number]);
  
  return (
    <div
      className={`${
        number === ""
          ? "intel-box"
          : !isValid
          ? "intel-box not-valid-itel"
          : "intel-box valid-intel"
      }`}
    >
      <IntlTelInput
        placeholder="Enter your mobile number"
        initialValue={selectedPhone !== "" ? selectedPhone : number}
        onChangeCountry={(ct) => {
          setCurrentCountry(ct);
        }}
        onChangeNumber={(num) => {
          setNumber(num);
          setFullPhone(num);
        }}
        onChangeValidity={(vd) => {
          setIsValid(vd);
          handleIntel(vd);
        }}

        onChangeErrorCode={setErrorCode}
        initOptions={{
          initialCountry: country?.country_code ? country?.country_code : "in",
          showSelectedDialCode: true,
          formatOnDisplay: false,
          nationalMode: false,
          /*  utilsScript: "https://intl-tel-input.com/intl-tel-input/js/utils.js?1713364227752", */
          utilsScript: "/js/utils.js",
          autoPlaceholder: "polite", // "off" disables it completely, "polite" allows custom
          customPlaceholder: () => "Enter Email/Mobile number",
          
        }}
      />
    </div>
  );
};

export default IntlTelInputBox;
